<div class="timeline-view">

  <div class="timeline-toolbar">

    @if (portfolioName(); as name) {

      <span class="portfolio-label">{{ name }} · cross-project timeline</span>

    }

    <mat-form-field appearance="outline">

      <mat-label>Zoom</mat-label>

      <mat-select [(ngModel)]="zoom" (ngModelChange)="onZoomChange()">

        @for (z of zoomOptions; track z.value) {

          <mat-option [value]="z.value">{{ z.label }}</mat-option>

        }

      </mat-select>

    </mat-form-field>

    <button mat-stroked-button type="button" (click)="loadTimeline()">

      <mat-icon>refresh</mat-icon> Refresh

    </button>

    @if (showShare && projectId && !portfolioId) {

      <button mat-stroked-button type="button" [disabled]="sharing()" (click)="shareRoadmap()">

        <mat-icon>share</mat-icon> {{ sharing() ? 'Sharing…' : 'Share roadmap' }}

      </button>

      <button mat-stroked-button type="button" [disabled]="exporting()" (click)="exportRoadmap()">

        <mat-icon>download</mat-icon> {{ exporting() ? 'Exporting…' : 'Export roadmap' }}

      </button>

    }

    @if (shareLink()) {

      <code class="share-link" matTooltip="Copied to clipboard">{{ shareLink() }}</code>

    }

    @if (loading()) { <mat-spinner diameter="24"></mat-spinner> }

  </div>



  @if (error()) {

    <p class="muted">{{ error() }}</p>

  }



  @if (!loading() && items().length) {

    <div class="timeline-header">

      <span class="lane-label">{{ isMultiProject() ? 'Project' : '' }}</span>

      <div class="timeline-scale">

        @if (rangeStart(); as rs) {

          <span>{{ rs | date:'mediumDate' }}</span>

        }

        @if (rangeEnd(); as re) {

          <span>{{ re | date:'mediumDate' }}</span>

        }

      </div>

    </div>



    @for (lane of lanes(); track lane) {

      <div class="timeline-lane">

        <div class="lane-label">{{ lane }}</div>

        <div class="lane-track">

          @for (item of laneItems(lane); track item.id) {

            <div class="timeline-bar" [class.critical-path]="isCritical(item)"
              [ngStyle]="barStyle(item)" [matTooltip]="barTooltip(item)"
              (dblclick)="openEdit(item)">

              @if (isMultiProject() && item.projectName) {

                <span class="bar-project">{{ item.projectName }}</span>

              }

              <span class="bar-label">{{ item.title }}</span>

              @if (item.progressPercent != null) {

                <span class="bar-progress">{{ item.progressPercent }}%</span>

              }

            </div>

          }

        </div>

      </div>

    }



    @if (dependencies().length) {

      <div class="dependencies">

        <h4>Dependencies ({{ dependencies().length }})</h4>

        <ul class="dep-list">

          @for (d of dependencyRows(); track d.fromTitle + d.toTitle) {

            <li>

              <span class="dep-from">

                @if (d.fromProject) { <span class="dep-project">{{ d.fromProject }}</span> }

                {{ d.fromTitle }}

              </span>

              <mat-icon class="dep-arrow">arrow_forward</mat-icon>

              <span class="dep-to">

                @if (d.toProject) { <span class="dep-project">{{ d.toProject }}</span> }

                {{ d.toTitle }}

              </span>

              @if (d.type) { <span class="dep-type">{{ d.type }}</span> }

            </li>

          }

        </ul>

      </div>

    }

  } @else if (!loading() && !error()) {

    <p class="muted">No timeline items in this range.</p>

  }



  @if (editingItem; as item) {

    <div class="edit-dialog">

      <h4>Edit {{ item.title }}</h4>

      <div class="edit-row">

        <mat-form-field appearance="outline">

          <mat-label>Start</mat-label>

          <input matInput type="date" [(ngModel)]="editStartDate" />

        </mat-form-field>

        <mat-form-field appearance="outline">

          <mat-label>End</mat-label>

          <input matInput type="date" [(ngModel)]="editEndDate" />

        </mat-form-field>

        <button mat-flat-button color="primary" type="button" (click)="saveEdit()">Save</button>

        <button mat-button type="button" (click)="cancelEdit()">Cancel</button>

      </div>

    </div>

  }

</div>


